import React, { Component } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

const GELECEK_RANDEVULAR_API = 'https://randevuapi.uzmdrzelihaaksoy.com/gelecek-randevular';

function formatTarih(tarih) {
  const [y, m, d] = tarih.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric', weekday: 'long' });
}

class GelecekRandevular extends Component {

  constructor(props) {
    super(props);

    this.auth = localStorage.getItem('auth');

    this.state = {
      loading: true,
      error: '',
      randevular: []
    };

    this.handleSSE = this.handleSSE.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }

  componentDidMount() {
    this.fetchRandevular();
    window.addEventListener('sse', this.handleSSE);
  }

  componentWillUnmount() {
    window.removeEventListener('sse', this.handleSSE);
  }

  handleBack() {
    this.props.history.goBack();
  }

  handleSSE(event) {
    if (event.detail && (event.detail.type === 'randevu-olusturuldu' || event.detail.type === 'randevu-guncellendi' || event.detail.type === 'randevu-silindi')) {
      this.fetchRandevular();
    }
  }

  fetchRandevular() {
    axios.get(GELECEK_RANDEVULAR_API, { headers: { Authorization: 'Basic ' + this.auth } })
      .then(response => {
        this.setState({ randevular: response.data, loading: false, error: '' });
      })
      .catch(() => {
        this.setState({ loading: false, error: 'Randevular alınamadı.' });
      });
  }

  render() {
    const { loading, error, randevular } = this.state;

    const gruplar = randevular.reduce((acc, randevu) => {
      if (!acc[randevu.tarih]) acc[randevu.tarih] = [];
      acc[randevu.tarih].push(randevu);
      return acc;
    }, {});

    const tarihler = Object.keys(gruplar).sort();

    return (
      <div className="max-w-lg mx-auto space-y-7">
        <header className="space-y-3">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-slate-900">Gelecek Randevular</h1>
          <button
            type="button" onClick={this.handleBack}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"></path></svg>
            Geri
          </button>
        </header>

        {loading && <p className="text-sm text-slate-500">Yükleniyor...</p>}
        {error && <p className="text-sm text-red-500">{error}</p>}

        {!loading && !error && tarihler.length === 0 && (
          <p className="text-sm text-slate-500">Gelecek randevu bulunmuyor.</p>
        )}

        {!loading && !error && tarihler.map(tarih => (
          <div key={tarih} className="space-y-2">
            <h2 className="bg-sky-100 rounded-xl border border-slate-500 divide-y divide-slate-100 px-4 py-3 text-sm font-semibold text-slate-700 capitalize">{formatTarih(tarih)}</h2>
            <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100 overflow-hidden">
              {gruplar[tarih]
                .slice()
                .sort((a, b) => a.saat.localeCompare(b.saat))
                .map((randevu, i) => (
                  <div key={i} className="flex items-center justify-between px-4 py-3">
                    <span className="text-sm text-slate-500 tabular-nums">{randevu.saat}</span>
                    <span className="flex items-center gap-1.5">
                      <span className="text-sm font-medium text-slate-800">{randevu.hasta_adi}</span>
                      <NavLink
                        to={`/randevu/${randevu.uuid}`}
                        aria-label="Randevu detayı"
                        title="Detay"
                        className="text-slate-400 hover:text-sky-600 transition-colors"
                      >
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="9"></circle>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M12 8h.01M11 11h1v5h1"></path>
                        </svg>
                      </NavLink>
                    </span>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default GelecekRandevular
